import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const CHEMICALTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ChemicalType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const CHEMICALTYPE_CONFIG = {
  entityName: 'ChemicalType',
  localizationKey: 'General::Entity.ChemicalType',
  fields: CHEMICALTYPE_FIELDS,
  permission: 'GeneralConsumables.ChemicalTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
